import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import onlyLogoWhite from '@/public/images/onlyLogo.webp';
import translationFallback from '@/utilites/translations/translationFallback';
import styles from './header/header.module.scss';

export default function DesktopBanner() {
  const { t: tCommon } = useTranslation('common');
  return (
    <div className={styles.desktopBanner}>
      <div
        className="d-flex align-items-center gap-2 text-white"
        style={{
          fontSize: '13.5px',
        }}
      >
        <div>
          <Image
            src={onlyLogoWhite}
            alt="Spiritory Logo"
            width={100}
            height={100}
          />
        </div>
        <div className="d-flex flex-column">
          <b>
            {translationFallback(
              'spiritory_whiskey_and_wine',
              tCommon('spiritory_whiskey_and_wine'),
              'Spiritory: Whiskey & Wine'
            )}
          </b>
          <span>
            {translationFallback(
              'download_the_app',
              tCommon('download_the_app'),
              'Download the app'
            )}
          </span>
        </div>
      </div>
      <a
        className={styles.downloadAppButton}
        href="https://linktr.ee/spiritory"
        target="_blank"
        rel="noreferrer"
      >
        {translationFallback('download', tCommon('download'), 'Download')}
      </a>
    </div>
  );
}
